var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33,
    height: 41,
    viewBox: "0 0 33 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9562 0.960938C14.6689 8.44994 13.4561 14.4661 10.1476 18.8793C10.1476 18.8793 11.4172 13.3331 6.76229 9.06685C7.18545 10.7733 2.53061 14.613 0.414755 22.2923C-1.7011 29.9715 4.22328 43.197 19.4574 40.6372C34.6915 38.0774 35.961 23.5721 28.7671 11.2C28.3439 18.026 23.2659 18.8793 23.2659 18.8793C23.2659 18.8793 24.5354 5.22719 13.9562 0.960938Z",
    fill: "#1F50B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3777 14.314C29.9006 13.2667 29.3637 12.2259 28.7671 11.2C28.344 18.026 23.2659 18.8792 23.2659 18.8792C23.2659 18.8792 24.5354 5.22719 13.9562 0.960938C14.6689 8.44994 13.4562 14.4661 10.1477 18.8793C10.1477 18.8793 11.4172 13.3331 6.76234 9.06685C7.18553 10.7733 2.53064 14.613 0.414805 22.2923C-0.638162 26.1139 0.300922 31.3086 3.38686 35.2482C15.596 33.6903 25.784 25.4961 30.3777 14.314Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20024 22.946C7.10931 25.0481 6.5851 26.8596 5.30006 27.061C4.03598 27.2721 2.49374 25.7953 2.58491 23.6931C2.65676 21.5911 4.34903 19.7722 5.61476 19.5708C6.89803 19.3595 7.27236 20.8439 7.20024 22.946Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77988 29.746C7.27447 30.6319 6.9478 31.4236 5.89238 31.5945C4.84125 31.7647 3.46006 31.2493 2.96551 30.3635C2.46687 29.4796 3.04453 28.5727 4.09588 28.4037C5.15136 28.2317 6.28119 28.8621 6.77988 29.746Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.51d4d8532aabe7e9ccf2.svg";
export { ForwardRef as ReactComponent };